import {
  FocusEvent,
  forwardRef,
  LegacyRef,
  TextareaHTMLAttributes,
} from 'react'

interface FormTextareaProps extends TextareaHTMLAttributes<HTMLTextAreaElement> {
  label?: string
  name?: string
  error?: any
  textColor?: 'black' | string
  onChange?: (e: any) => void
  hasTrimValue?: boolean
}

export const FormTextarea = forwardRef(
  (props: FormTextareaProps, ref: LegacyRef<HTMLTextAreaElement>) => {
    const {
      label,
      name,
      error,
      textColor,
      className,
      onChange,
      hasTrimValue,
      ...textareaProps
    } = props

    const handleChange = (e: any) => {
      const changeEvent = {
        target: {
          name: e.target.name,
          value: e.target.value,
        },
      }
      onChange?.(changeEvent)
    }

    const handleBlur = (e: FocusEvent<HTMLTextAreaElement, Element>) => {
      if (hasTrimValue) {
        e.target.value = e.target.value.trim()
      }
      onChange?.(e)
      textareaProps.onBlur?.(e)
    }

    return (
      <div
        className={`w-full mb-2 ${
          error ? 'is-invalid' : ''
        } text-[${textColor}]`}
      >
        <label
          className="block text-sm font-semibold text-gray-710"
          htmlFor={name}
        >
          {label}
        </label>
        <textarea
          ref={ref}
          className={className}
          id={name}
          name={name}
          onChange={handleChange}
          {...textareaProps}
          onBlur={handleBlur}
        />
        {error && (
          <div className="mt-1 text-[12px] leading-[23px] text-red min-h-[20px]">
            {error.message}
          </div>
        )}
      </div>
    )
  },
)

FormTextarea.defaultProps = {
  label: '',
  name: '',
  error: null,
  textColor: 'black',
  onChange: () => null,
  hasTrimValue: false,
}
